import React, { useEffect, useState } from 'react'
import { AppConstantes } from '../../../../utils/Constantes'
import { ModalEditarAgregarCondicionante } from '../modalAgregarEditarCondicionante/ModalAgregarEditarCondicionante'
import { ModalAgregarEditarTarea } from '../../../tareas/components/ModalAgregarEditarTarea'
import { useNavigate, useParams, Link } from 'react-router-dom'
import { useRecuperarAutorizacionPorIdQuery } from '../../../../redux/api'
import { DetalleAutorizacionCardAutorizacion } from './DetalleAutorizacionCardAutorizacion'
import { DetalleAutorizacionCardCondicionantes } from './DetalleAutorizacionCardCondicionantes'
import { DetalleAutorizacionCardTareas } from './DetalleAutorizacionCardTareas'
import { Tarea } from '../../../tareas/models'
import { Condicionante } from '../../models'
import { ModalAgregarEditarRecordatorio } from './ModalAgregarEditarRecordatorio'
import { ModalAgregarEditarReportes } from './ModalAgregarEditarReportes'
import { CargaInfo } from '../../../../components/layout/CargaInfo'
import { useDispatch } from 'react-redux'
import { cargarTareas } from '../../../../redux/slices/tareas'
import useHasPermiso from '../../../../hooks/autenticacion/useHasPermiso'
import { Roles } from '../../../../utils/Roles'
export const DetalleAutorizacion = () => {
  const { hasPermiso } = useHasPermiso()
  const usuarioPermisoAutorizacion = hasPermiso([Roles.roleAutorizacionesCrear])

  const { idAutorizacion } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const isAutorizacionCargada = !!idAutorizacion
  const idAutorizacionSeleccionada = `autorizacion/${idAutorizacion}`

  const [condicionantesRecuperadas, setCondicionantesRecuperadas] = useState<Condicionante[]>()
  const [idCondicionanteSeleccionada, setIdCondicionanteSeleccionada] = useState('')
  const [idSeleccionado, setIdSeleccionado] = useState(`autorizacion/${idAutorizacion}`)

  const [mostrarModalRecordatorio, setMostrarModalRecordatorio] = useState(false)
  const [mostrarModalReporte, setMostrarModalReporte] = useState(false)
  const [mostrarModalTarea, setMostrarModalTarea] = useState(false)
  const [mostrarModalCondicionante, setMostrarModalCondicionante] = useState(false)
  const [isModoEditar, setIsModoEditar] = useState(false)
  const [claveNivel, setClaveNivel] = useState(AppConstantes.CLAVE_NIVEL_AUTORIZACION)
  const [condicionanteSeleccionada, setCondicionanteSeleccionada] = useState<
    Condicionante | undefined
  >()
  const [tareaSeleccionada, setTareaSeleccionada] = useState<Tarea>()

  const [isSuccessActualizarCondicionante, setIsSuccessActualizarCondicionante] =
    useState<boolean>()
  const [isSuccessGuardarCondicionante, setIsSuccessGuardarCondicionante] = useState<boolean>()
  const [isSuccessActualizarTarea, setIsSuccessActualizarTarea] = useState<boolean>()
  const [isSuccessGuardarTarea, setIsSuccessGuardarTarea] = useState<boolean>()

  const {
    data: autorizacion,
    refetch,
    isSuccess: isSuccessRecuperarAutorizacion,
    isLoading: isLoadingRecuperarAutorizacion,
    isError: isErrorRecuperarAutorizacion,
    error,
  } = useRecuperarAutorizacionPorIdQuery(idAutorizacion ? idAutorizacion : '', {
    skip: !isAutorizacionCargada,
  })

  useEffect(() => {
    // Sincroniza selección y datos derivados a partir del detalle de autorización.
    // `claveNivel` controla si la tarjeta de tareas muestra tareas de autorización o de condicionante.
    if (isSuccessRecuperarAutorizacion && claveNivel === 'autorizacion') {
      setIdSeleccionado(`autorizacion/${idAutorizacion}`)
    }
    if (isSuccessRecuperarAutorizacion && claveNivel === 'condicionante') {
      setCondicionantesRecuperadas(autorizacion.condicionantes)
    }
  }, [isSuccessRecuperarAutorizacion])

  /**
   * @description Controla el cierre del modal de tareas.
   *              Al cerrar se limpia el modo edición para que el próximo open inicie limpio.
   *
   * @author luis.durazo, Hábil MX
   * @version 1.0.0, 15/11/2022
   */
  const cerrarModalTarea = () => {
    setMostrarModalTarea(false)
    setIsModoEditar(false)
  }

  /**
   * @description Cierre del modal condicionante.
   *              Al cerrar se limpia el modo edición.
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 17/11/2022
   */
  const cerrarModalCondicionante = () => {
    setMostrarModalCondicionante(false)
    setIsModoEditar(false)
  }

  /**
   * @description Cierre del modal recordatorios.
   *              Hace refetch del detalle para refrescar recordatorios.
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 17/11/2022
   */
  const cerrarModalRecordatorio = () => {
    setMostrarModalRecordatorio(false)
    refetch()
  }

  /**
   * @description Cierre del modal de reportes/documentos.
   *              Hace refetch del detalle para refrescar evidencia asociada.
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 17/11/2022
   */
  const cerrarModalReporte = () => {
    setMostrarModalReporte(false)
    refetch()
  }
  return (
    <>
      {mostrarModalReporte && (
        <ModalAgregarEditarReportes
          idRelacionado={autorizacion?.idAutorizacion}
          titulo='Documentos asociados'
          nombre={autorizacion?.numero}
          show={true}
          close={cerrarModalReporte}
          isModoEditar={true}></ModalAgregarEditarReportes>
      )}

      {mostrarModalRecordatorio && (
        <ModalAgregarEditarRecordatorio
          idRelacionado={autorizacion?.idAutorizacion}
          titulo='Recordatorios'
          nombre={autorizacion?.numero}
          show={true}
          close={cerrarModalRecordatorio}
          refetch={refetch}
          isModoEditar={true}
          esIndefinida={autorizacion?.esIndefinida}
          recordatorios={autorizacion?.recordatorios}></ModalAgregarEditarRecordatorio>
      )}
      {mostrarModalCondicionante && (
        <ModalEditarAgregarCondicionante
          idSitio={autorizacion?.idSitio}
          idAutorizacion={idAutorizacion?.toString()}
          show={mostrarModalCondicionante}
          close={cerrarModalCondicionante}
          titulo={isModoEditar ? 'Editar condicionante' : 'Nueva condicionante'}
          condicionante={condicionanteSeleccionada}
          fechaVencimientoAutorizacion={autorizacion?.fechaVencimiento}
          unidadAutorizacion={autorizacion?.unidadDuracion}
          isModoEditar={isModoEditar}
          refetch={refetch}
          idSeleccionado={idSeleccionado}
          setIsSuccessActualizar={setIsSuccessActualizarCondicionante}
          setIsSuccessGuardar={setIsSuccessGuardarCondicionante}></ModalEditarAgregarCondicionante>
      )}

      {mostrarModalTarea && (
        <ModalAgregarEditarTarea
          show={mostrarModalTarea}
          close={cerrarModalTarea}
          isModoEditar={isModoEditar}
          idTarea={tareaSeleccionada?.idTarea ?? ''}
          claveNivelTarea={claveNivel}
          autorizacion={autorizacion}
          condicionante={condicionanteSeleccionada}
          setIsSuccessActualizar={setIsSuccessActualizarTarea}
          setIsSuccessGuardar={setIsSuccessGuardarTarea}
        />
      )}

      <div className='d-flex  mb-3 justify-content-between '>
        <div className='d-flex align-items-center flex-grow-1'>
          <h1>{autorizacion?.numero}</h1>
        </div>

        <Link to={`/autorizaciones/editar/${idAutorizacion}`} className='text-white me-2'>
          <button className='btn btn-primary'>
            {' '}
            {usuarioPermisoAutorizacion && <i className='fa-solid fa-pen-to-square fs-4 me-1'></i>}
            {usuarioPermisoAutorizacion ? 'Editar' : 'Ver información'}
            {!usuarioPermisoAutorizacion && <i className='fa-solid fa-arrow-right ms-3 fs-4 '> </i>}
          </button>
        </Link>
        <button
          className='btn btn-light-primary'
          onClick={() => {
            // Limpia el slice de tareas para evitar que queden tareas del detalle
            // cuando se regresa a listados/pantallas previas.
            dispatch(cargarTareas([]))
            navigate(-1)
          }}>
          <i className='fa-solid fa-xmark fs-4 '> </i> Cerrar
        </button>
      </div>
      <div className='row'>
        {isLoadingRecuperarAutorizacion || isErrorRecuperarAutorizacion ? (
          <div className='col-12'>
            <CargaInfo
              mensaje={'Recuperando autorización'}
              isError={isErrorRecuperarAutorizacion}
              mensajeError={'Ocurrió un error al recuperar el detalle de la autorización'}
              errorApi={error}
            />
          </div>
        ) : (
          isSuccessRecuperarAutorizacion && (
            <>
              {/* Card Autorizacion */}
              <DetalleAutorizacionCardAutorizacion
                autorizacion={autorizacion}
                setMostrarModalRecordatorio={setMostrarModalRecordatorio}
                setMostrarModalReporte={setMostrarModalReporte}
              />
              {/* Card Condicionantes */}
              <DetalleAutorizacionCardCondicionantes
                autorizacion={autorizacion}
                condicionantes={condicionantesRecuperadas}
                claveNivel={claveNivel}
                condicionanteSeleccionada={condicionanteSeleccionada}
                setIsModoEditar={setIsModoEditar}
                setMostrarModalCondicionante={setMostrarModalCondicionante}
                setCondicionanteSeleccionada={setCondicionanteSeleccionada}
                setClaveNivel={setClaveNivel}
                setIdSeleccionado={setIdSeleccionado}
                isSuccessRecuperarAutorizacion={isSuccessRecuperarAutorizacion}
                setIdCondicionanteSeleccionada={setIdCondicionanteSeleccionada}
                isSuccessActualizar={isSuccessActualizarCondicionante}
                isSuccessGuardar={isSuccessGuardarCondicionante}
              />
              {/* Card Tareas */}
              <DetalleAutorizacionCardTareas
                condicionanteSeleccionada={condicionanteSeleccionada}
                setCondicionanteSeleccionada={setCondicionanteSeleccionada}
                setTareaSeleccionada={setTareaSeleccionada}
                claveNivel={claveNivel}
                setClaveNivel={setClaveNivel}
                idSeleccionado={idSeleccionado}
                setIdSeleccionado={setIdSeleccionado}
                idAutorizacion={idAutorizacion}
                idAutorizacionSeleccionada={idAutorizacionSeleccionada}
                idCondicionanteSeleccionada={idCondicionanteSeleccionada}
                mostrarModalTarea={mostrarModalTarea}
                setMostrarModalTarea={setMostrarModalTarea}
                isSuccessGuardar={isSuccessGuardarTarea}
                isSuccessActualizar={isSuccessActualizarTarea}
                isSuccessRecuperarAutorizacion={isSuccessRecuperarAutorizacion}
                setIsModoEditar={setIsModoEditar}
              />
            </>
          )
        )}
      </div>
    </>
  )
}

export default DetalleAutorizacion
